import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SearchItinerary'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SearchItineraryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SearchItineraryStore",
			variables: true,
		})
	}
}

export async function load_SearchItinerary(params) {
  await initClient()

	const store = new SearchItineraryStore()

	await store.fetch(params)

	return {
		SearchItinerary: store,
	}
}
